import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import Vue from 'vue';
import Meta from 'vue-meta';
import ClientOnly from 'vue-client-only';
import NoSsr from 'vue-no-ssr';
import { createRouter } from './router.js';
import NuxtChild from './components/nuxt-child.js';
import NuxtError from '../layouts/error.vue';
import Nuxt from './components/nuxt.js';
import App from './App.js';
import { setContext, getLocation, getRouteData, normalizeError } from './utils';

/* Plugins */

import nuxt_plugin_plugin_6fa39586 from 'nuxt_plugin_plugin_6fa39586'; // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_84f25ed2 from 'nuxt_plugin_sentryserver_84f25ed2'; // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_57cd5f0f from 'nuxt_plugin_sentryclient_57cd5f0f'; // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_5a365fd1 from 'nuxt_plugin_plugin_5a365fd1'; // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_appplugin_099a9b3f from 'nuxt_plugin_appplugin_099a9b3f'; // Source: ../node_modules/@nuxt/bridge/dist/runtime/app.plugin.mjs (mode: 'all')
import nuxt_plugin_configplugin_06e147f0 from 'nuxt_plugin_configplugin_06e147f0'; // Source: ../node_modules/@nuxt/bridge/dist/runtime/config.plugin.mjs (mode: 'all')
import nuxt_plugin_deviceplugin_40a6af44 from 'nuxt_plugin_deviceplugin_40a6af44'; // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_unhead_032473a0 from 'nuxt_plugin_unhead_032473a0'; // Source: ../node_modules/@nuxt/bridge/dist/runtime/head/plugins/unhead (mode: 'all')
import nuxt_plugin_capiplugin_162a9a60 from 'nuxt_plugin_capiplugin_162a9a60'; // Source: ./capi.plugin.mjs (mode: 'all')
import nuxt_plugin_errorpluginserver_b30fcb6e from 'nuxt_plugin_errorpluginserver_b30fcb6e'; // Source: ../node_modules/@nuxt/bridge/dist/runtime/error.plugin.server.mjs (mode: 'server')
import nuxt_plugin_distplugin577e8889_02249ade from 'nuxt_plugin_distplugin577e8889_02249ade'; // Source: ./dist.plugin.577e8889.mjs (mode: 'all')
import nuxt_plugin_captureException_71a2459d from 'nuxt_plugin_captureException_71a2459d'; // Source: ../plugins/captureException (mode: 'all')
import nuxt_plugin_featureflags_573a837c from 'nuxt_plugin_featureflags_573a837c'; // Source: ../plugins/feature-flags (mode: 'all')
import nuxt_plugin_mask_9266ba40 from 'nuxt_plugin_mask_9266ba40'; // Source: ../plugins/mask (mode: 'all')
import nuxt_plugin_captcha_7e9af206 from 'nuxt_plugin_captcha_7e9af206'; // Source: ../plugins/captcha (mode: 'all')
import nuxt_plugin_recaptcha_78653d1a from 'nuxt_plugin_recaptcha_78653d1a'; // Source: ../plugins/recaptcha (mode: 'all')
import nuxt_plugin_mailcalendar_dd64e5c0 from 'nuxt_plugin_mailcalendar_dd64e5c0'; // Source: ../plugins/mail-calendar (mode: 'all')
import nuxt_plugin_googlegtag_c551cb1a from 'nuxt_plugin_googlegtag_c551cb1a'; // Source: ../plugins/google-gtag (mode: 'all')
import nuxt_plugin_yandexmetrika_634e2ec1 from 'nuxt_plugin_yandexmetrika_634e2ec1'; // Source: ../plugins/yandex-metrika (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly);

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, _objectSpread(_objectSpread({}, NoSsr), {}, {
  render: function render(h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true;
      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead');
    }
    return NoSsr.render(h, ctx);
  }
}));

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild);
Vue.component('NChild', NuxtChild);

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt);
Object.defineProperty(Vue.prototype, '$nuxt', {
  get: function get() {
    var globalNuxt = this.$root ? this.$root.$options.$nuxt : null;
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt;
    }
    return globalNuxt;
  },
  configurable: true
});
Vue.use(Meta, {
  "keyName": "head",
  "attribute": "data-n-head",
  "ssrAttribute": "data-n-head-ssr",
  "tagIDKeyName": "hid"
});
var defaultTransition = {
  "name": "page",
  "mode": "out-in",
  "appear": true,
  "appearClass": "appear",
  "appearActiveClass": "appear-active",
  "appearToClass": "appear-to"
};
function createApp(_x) {
  return _createApp.apply(this, arguments);
}
function _createApp() {
  _createApp = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(ssrContext) {
    var config,
      store,
      router,
      app,
      next,
      route,
      path,
      inject,
      _args2 = arguments;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          inject = function _inject(key, value) {
            if (!key) {
              throw new Error('inject(key, value) has no key provided');
            }
            if (value === undefined) {
              throw new Error("inject('".concat(key, "', value) has no value provided"));
            }
            key = '$' + key;
            // Add into app
            app[key] = value;
            // Add into context
            if (!app.context[key]) {
              app.context[key] = value;
            }

            // Check if plugin not already installed
            var installKey = '__nuxt_' + key + '_installed__';
            if (Vue[installKey]) {
              return;
            }
            Vue[installKey] = true;
            // Call Vue.use() to install the plugin into vm
            Vue.use(function () {
              if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
                Object.defineProperty(Vue.prototype, key, {
                  get: function get() {
                    return this.$root.$options[key];
                  }
                });
              }
            });
          };
          config = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
          store = null;
          _context2.next = 5;
          return createRouter(ssrContext, config, {
            store: store
          });
        case 5:
          router = _context2.sent;
          // Create Root instance
          // here we inject the router and store to all child components,
          // making them available everywhere as `this.$router` and `this.$store`.
          app = _objectSpread({
            head: {
              "title": "Личный кабинет",
              "htmlAttrs": {
                "lang": "ru"
              },
              "meta": [{
                "charset": "utf-8"
              }, {
                "hid": "viewport",
                "name": "viewport",
                "content": "width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0"
              }, {
                "hid": "robots",
                "name": "robots",
                "content": "noindex"
              }, {
                "hid": "description",
                "name": "description",
                "content": ""
              }, {
                "hid": "smart-banner",
                "name": "apple-itunes-app",
                "content": "app-id=1591602076"
              }],
              "link": [{
                "rel": "icon",
                "type": "image/x-icon",
                "href": "/favicons/favicon.ico"
              }, {
                "rel": "icon",
                "type": "image/svg+xml",
                "href": "/favicons/favicon.svg"
              }, {
                "rel": "icon",
                "type": "image/png",
                "sizes": "16x16",
                "href": "/favicons/favicon-16x16.png"
              }, {
                "rel": "icon",
                "type": "image/png",
                "sizes": "32x32",
                "href": "/favicons/favicon-32x32.png"
              }, {
                "rel": "icon",
                "type": "image/png",
                "sizes": "192x192",
                "href": "/favicons/android-chrome-192x192.png"
              }, {
                "rel": "icon",
                "type": "image/png",
                "sizes": "512x512",
                "href": "/favicons/android-chrome-512x512.png"
              }, {
                "rel": "apple-touch-icon",
                "sizes": "180x180",
                "href": "/favicons/apple-touch-icon-180.png"
              }],
              "script": [{
                "src": "https://meet.medtochka.ru/external_api.js",
                "body": true,
                "async": true
              }, {
                "src": "https://polyfill.medrocket.ru/v3/polyfill.min.js?version=3.111.0&features=ResizeObserver%2CIntersectionObserverEntry%2CIntersectionObserver&flags=gated",
                "body": true,
                "async": true
              }],
              "style": []
            },
            router: router,
            nuxt: {
              defaultTransition: defaultTransition,
              transitions: [defaultTransition],
              setTransitions: function setTransitions(transitions) {
                if (!Array.isArray(transitions)) {
                  transitions = [transitions];
                }
                transitions = transitions.map(function (transition) {
                  if (!transition) {
                    transition = defaultTransition;
                  } else if (typeof transition === 'string') {
                    transition = Object.assign({}, defaultTransition, {
                      name: transition
                    });
                  } else {
                    transition = Object.assign({}, defaultTransition, transition);
                  }
                  return transition;
                });
                this.$options.nuxt.transitions = transitions;
                return transitions;
              },
              err: null,
              errPageReady: false,
              dateErr: null,
              error: function error(err) {
                err = err || null;
                app.context._errored = Boolean(err);
                err = err ? normalizeError(err) : null;
                var nuxt = app.nuxt; // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
                if (this) {
                  nuxt = this.nuxt || this.$options.nuxt;
                }
                nuxt.dateErr = Date.now();
                nuxt.err = err;
                nuxt.errPageReady = false;
                // Used in src/server.js
                if (ssrContext) {
                  ssrContext.nuxt.error = err;
                }
                return err;
              }
            }
          }, App);
          next = ssrContext ? ssrContext.next : function (location) {
            return app.router.push(location);
          }; // Resolve route
          if (ssrContext) {
            route = router.resolve(ssrContext.url).route;
          } else {
            path = getLocation(router.options.base, router.options.mode);
            route = router.resolve(path).route;
          }

          // Set context to app.context
          _context2.next = 11;
          return setContext(app, {
            route: route,
            next: next,
            error: app.nuxt.error.bind(app),
            payload: ssrContext ? ssrContext.payload : undefined,
            req: ssrContext ? ssrContext.req : undefined,
            res: ssrContext ? ssrContext.res : undefined,
            beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
            beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
            ssrContext: ssrContext
          });
        case 11:
          // Inject runtime config as $config
          inject('config', config);

          // Add enablePreview(previewData = {}) in context for plugins
          if (process.static && process.client) {
            app.context.enablePreview = function () {
              var previewData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              app.previewData = Object.assign({}, previewData);
              inject('preview', previewData);
            };
          }
          // Plugin execution
          if (!(typeof nuxt_plugin_plugin_6fa39586 === 'function')) {
            _context2.next = 16;
            break;
          }
          _context2.next = 16;
          return nuxt_plugin_plugin_6fa39586(app.context, inject);
        case 16:
          if (!(process.server && typeof nuxt_plugin_sentryserver_84f25ed2 === 'function')) {
            _context2.next = 19;
            break;
          }
          _context2.next = 19;
          return nuxt_plugin_sentryserver_84f25ed2(app.context, inject);
        case 19:
          if (!(process.client && typeof nuxt_plugin_sentryclient_57cd5f0f === 'function')) {
            _context2.next = 22;
            break;
          }
          _context2.next = 22;
          return nuxt_plugin_sentryclient_57cd5f0f(app.context, inject);
        case 22:
          if (!(typeof nuxt_plugin_plugin_5a365fd1 === 'function')) {
            _context2.next = 25;
            break;
          }
          _context2.next = 25;
          return nuxt_plugin_plugin_5a365fd1(app.context, inject);
        case 25:
          if (!(typeof nuxt_plugin_appplugin_099a9b3f === 'function')) {
            _context2.next = 28;
            break;
          }
          _context2.next = 28;
          return nuxt_plugin_appplugin_099a9b3f(app.context, inject);
        case 28:
          if (!(typeof nuxt_plugin_configplugin_06e147f0 === 'function')) {
            _context2.next = 31;
            break;
          }
          _context2.next = 31;
          return nuxt_plugin_configplugin_06e147f0(app.context, inject);
        case 31:
          if (!(typeof nuxt_plugin_deviceplugin_40a6af44 === 'function')) {
            _context2.next = 34;
            break;
          }
          _context2.next = 34;
          return nuxt_plugin_deviceplugin_40a6af44(app.context, inject);
        case 34:
          if (!(typeof nuxt_plugin_unhead_032473a0 === 'function')) {
            _context2.next = 37;
            break;
          }
          _context2.next = 37;
          return nuxt_plugin_unhead_032473a0(app.context, inject);
        case 37:
          if (!(typeof nuxt_plugin_capiplugin_162a9a60 === 'function')) {
            _context2.next = 40;
            break;
          }
          _context2.next = 40;
          return nuxt_plugin_capiplugin_162a9a60(app.context, inject);
        case 40:
          if (!(process.server && typeof nuxt_plugin_errorpluginserver_b30fcb6e === 'function')) {
            _context2.next = 43;
            break;
          }
          _context2.next = 43;
          return nuxt_plugin_errorpluginserver_b30fcb6e(app.context, inject);
        case 43:
          if (!(typeof nuxt_plugin_distplugin577e8889_02249ade === 'function')) {
            _context2.next = 46;
            break;
          }
          _context2.next = 46;
          return nuxt_plugin_distplugin577e8889_02249ade(app.context, inject);
        case 46:
          if (!(typeof nuxt_plugin_captureException_71a2459d === 'function')) {
            _context2.next = 49;
            break;
          }
          _context2.next = 49;
          return nuxt_plugin_captureException_71a2459d(app.context, inject);
        case 49:
          if (!(typeof nuxt_plugin_featureflags_573a837c === 'function')) {
            _context2.next = 52;
            break;
          }
          _context2.next = 52;
          return nuxt_plugin_featureflags_573a837c(app.context, inject);
        case 52:
          if (!(typeof nuxt_plugin_mask_9266ba40 === 'function')) {
            _context2.next = 55;
            break;
          }
          _context2.next = 55;
          return nuxt_plugin_mask_9266ba40(app.context, inject);
        case 55:
          if (!(typeof nuxt_plugin_captcha_7e9af206 === 'function')) {
            _context2.next = 58;
            break;
          }
          _context2.next = 58;
          return nuxt_plugin_captcha_7e9af206(app.context, inject);
        case 58:
          if (!(typeof nuxt_plugin_recaptcha_78653d1a === 'function')) {
            _context2.next = 61;
            break;
          }
          _context2.next = 61;
          return nuxt_plugin_recaptcha_78653d1a(app.context, inject);
        case 61:
          if (!(typeof nuxt_plugin_mailcalendar_dd64e5c0 === 'function')) {
            _context2.next = 64;
            break;
          }
          _context2.next = 64;
          return nuxt_plugin_mailcalendar_dd64e5c0(app.context, inject);
        case 64:
          if (!(typeof nuxt_plugin_googlegtag_c551cb1a === 'function')) {
            _context2.next = 67;
            break;
          }
          _context2.next = 67;
          return nuxt_plugin_googlegtag_c551cb1a(app.context, inject);
        case 67:
          if (!(typeof nuxt_plugin_yandexmetrika_634e2ec1 === 'function')) {
            _context2.next = 70;
            break;
          }
          _context2.next = 70;
          return nuxt_plugin_yandexmetrika_634e2ec1(app.context, inject);
        case 70:
          // Lock enablePreview in context
          if (process.static && process.client) {
            app.context.enablePreview = function () {
              console.warn('You cannot call enablePreview() outside a plugin.');
            };
          }

          // Wait for async component to be resolved first
          _context2.next = 73;
          return new Promise(function (resolve, reject) {
            // Ignore 404s rather than blindly replacing URL in browser
            if (process.client) {
              var _router$resolve = router.resolve(app.context.route.fullPath),
                _route = _router$resolve.route;
              if (!_route.matched.length) {
                return resolve();
              }
            }
            router.replace(app.context.route.fullPath, resolve, function (err) {
              // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
              if (!err._isRouter) return reject(err);
              if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve();

              // navigated to a different route in router guard
              var unregister = router.afterEach(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from) {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if (process.server && ssrContext && ssrContext.url) {
                          ssrContext.url = to.fullPath;
                        }
                        _context.next = 3;
                        return getRouteData(to);
                      case 3:
                        app.context.route = _context.sent;
                        app.context.params = to.params || {};
                        app.context.query = to.query || {};
                        unregister();
                        resolve();
                      case 8:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x2, _x3) {
                  return _ref.apply(this, arguments);
                };
              }());
            });
          });
        case 73:
          return _context2.abrupt("return", {
            app: app,
            router: router
          });
        case 74:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _createApp.apply(this, arguments);
}
export { createApp, NuxtError };